import React, { memo } from 'react'
import clsx from 'clsx'
import { useAppSelector } from '../app/hooks/reduxHooks'
import styles from './Sidebar.module.sass'

export function toSnakeCase(str) {
    return str.toLowerCase().split(' ').join('_')
}

function Sidebar({ elements }) {
    const active = useAppSelector(state => state.pageIndex.index)
    return (
        <div className={styles.root} >
            <ul className={clsx(styles.ul, styles.hideLi)} >
                {elements.map((e, i) =>
                    <li
                        className={clsx(i === active && styles.liActive, styles.li)}
                        key={i}>
                        <a
                            className={styles.a}
                            href={`#${toSnakeCase(e)}`} >
                            {e}
                        </a>
                    </li>)
                }
            </ul>
        </div >
    )
}

export default memo(Sidebar)